import { notificationsTypes } from '../../types';
import { isDevelopment, isProduction } from '../../../helpers';

const prepareErrorMessage = (message, name, alertType) => {
    // eslint-disable-next-line
    let errorMessage = '';

    if (isDevelopment()) {
        if (alertType && alertType === 'development') {
            errorMessage += '(DEVELOPMENT) -- ';
        }

        errorMessage += (name && `${name}: `) || '';
        errorMessage += message || '';
    }

    if (isProduction()) {
        errorMessage += message || 'Lo sentímos, ocurrió un error inesperado.';
    }

    return errorMessage;
};

const getErrorMessage = error => {
    if (typeof error === 'string') {
        return prepareErrorMessage(error);
    }

    if (error && error.message) {
        if (isDevelopment()) {
            console.log(error);
        }

        return prepareErrorMessage(error.message, error.name, 'development');
    }

    if (error && error.code) {
        if (isDevelopment()) {
            console.log(error);
        }

        prepareErrorMessage(error.code, error.name, 'development');
    }

    return '';
};

const showFailedNotification = error => {
    return {
        type: notificationsTypes.SHOW_FAILED_NOTIFICATION,
        payload: { status: true, errorMsg: getErrorMessage(error) },
    };
};

export default showFailedNotification;
